import {
  Avatar,
  Box,
  Button,
  Collapse,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Images from "../../assets";
import { maskInput } from "../../assets/library";
import { useEffect,  useRef,  useState } from "react";
import { switchStudentActivity } from "../../services";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
import { updateStudentProfile } from "../../store/slices/studentsInfo";
import Socket from "../../assets/socket";
import { useNavigate } from "react-router-dom";

export const StudentName = (props: any) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (props?.name === "Deleted User"){
      
    } 
    else if(props.type === "student") {
      navigate(`/student/${props.id}/personal`);
    } else if (props.type === "application") {
      navigate(`/application/${props.id}`);
    }
  };
  return (
    <div>
      <Box
        sx={{ display: "flex", gap: "20px", alignItems: "center",cursor:"pointer" }}
        onClick={handleClick}
      >
        <Avatar
          src={
            props?.displayPicSrc
              ? props?.displayPicSrc
              : "https://res.cloudinary.com/dffdp7skh/image/upload/v1706879929/nvitahnrlhvmtcizpthx.png"
          }
          alt=""
          style={{ width: "2.5rem", height: "2.5rem", borderRadius: "50%" }}
        />
        {props?.name}
      </Box>
    </div>
  );
};
interface StageProps {
  stage: string;
  id: string;
}

export const Stage: React.FC<StageProps> = (props) => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.profileInfo);
  const studentInfo = useAppSelector((state) => state.studentInfo);
  const listRef = useRef<HTMLUListElement | null>(null);
  const [selectedStage, setSelectedStage] = useState<string>(props.stage);
  const [inputValues, setInputValues] = useState<{ [key: string]: string }>({});
  const [expandedStage, setExpandedStage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [isListOpen, setIsListOpen] = useState<boolean>(false);

  const stages = [
    'Fresh Lead',
    'Counselling',
    'Follow up 1',
    'Follow Up 2',
    'Final Shortlist',
    'Closed Lead',
    'Reopened',
  ];

  const handleStageClick = (stage: string) => {
    setExpandedStage(stage === expandedStage ? null : stage);
    setSelectedStage(stage);
  };

  const handleInputChange = (event: any, stage: string) => {
    const { name, value } = event.target;
    setInputValues({ ...inputValues, [`${stage}-${name}`]: value });
  };

  const handleSubmit = async (stage: string) => {
    setLoading(true);
    try {
      console.log({
        studentId: props.id,
        stage: selectedStage,
        note: inputValues[`${stage}-note`],
        nextActionDate: inputValues[`${stage}-nextActionDate`],
      })
      const response = await switchStudentActivity({
        studentId: props.id,
        stage: selectedStage,
        note: inputValues[`${stage}-note`],
        nextActionDate: inputValues[`${stage}-nextActionDate`],
      });
      if (response) {
        console.log(response);

        let currentProfile = studentInfo.data.find((profile) => profile._id === props.id);
        if (currentProfile) {
          dispatch(updateStudentProfile({ ...currentProfile, stage: selectedStage }));
          setIsListOpen(false);
          setLoading(false);
        }
        const triggerObject = {
          action: "stageChangeCounsellor",
          sender: profile.data,
          recievers: [response?.data.data.user],
          data: response.data.data,
        };
        // console.log("trigger", triggerObject);
  
        Socket.emit("trigger", triggerObject);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (listRef.current && !listRef.current.contains(event.target as Node)) {
      setIsListOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box sx={{  width: '100%' }}>
      <Button
        onClick={() => setIsListOpen(!isListOpen)}
        sx={{
          color: '#000',
          backgroundColor: props.stage === 'Fresh Lead' ? '#FBE3C8' : '#F0F1F9 !important',
          textTransform: 'none',
        }}
      >
        {props.stage}
      </Button>
      <Collapse in={isListOpen} timeout="auto" unmountOnExit>
        <Paper
          elevation={1}
          sx={{
            mt: 2,
            position: 'absolute',
            zIndex: 1,
            top: "20%",
            boxShadow: 2,
            width: '300px',
          }}
        >
          <List ref={listRef} sx={{height:"250px",overflowY:"scroll"}}>
            {stages.map((stage) => (
              <div key={stage}>
                <ListItem button onClick={() => handleStageClick(stage)} disabled={stage === selectedStage} >
                  <ListItemText primary={stage} sx={{
                    "& .MuiTypography-root":{
fontSize:"14px"
                    }
                    }}/>
                </ListItem>
                <Collapse in={expandedStage === stage} timeout="auto" unmountOnExit>
                  <Box sx={{ pl: 4, pr: 4, pb: 2 }}>
                    <TextField
                      size="small"
                      fullWidth
                      name="note"
                      value={inputValues[`${stage}-note`] || ''}
                      onChange={(event) => handleInputChange(event, stage)}
                      placeholder="Add Note"
                      sx={{ my: 1 }}
                    />
                    <Typography>Next action date</Typography>
                    <TextField
                      size="small"
                      fullWidth
                      type="date"
                      name="nextActionDate"
                      value={inputValues[`${stage}-nextActionDate`] || ''}
                      onChange={(event) => handleInputChange(event, stage)}
                      sx={{ mb: 1 }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleSubmit(stage)}
                      sx={{
                        backgroundColor: '#3B3F76',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '13px',
                        width: '80px',
                        textTransform: 'none',
                        borderRadius: '10px',
                        '&:hover': {
                          backgroundColor: '#3B3F76',
                          color: '#fff',
                        },
                      }}
                    >
                      {loading ? (
                        <img
                          src={Images.standardLoader}
                          alt="load"
                          style={{
                            width: '20px',
                            height: '20px',
                            padding: '5px',
                          }}
                        />
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </Box>
                </Collapse>
              </div>
            ))}
          </List>
        </Paper>
      </Collapse>
    </Box>
  );
};

export const Email = (props: any) => {
  const emailVerification = props?.verification?.find(
    (verificationItem: any) => verificationItem?.type === "email"
  );
  const maskedEmail = maskInput(props?.email, "email");
  return (
    <div>
      <Typography
        fontSize="14px"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        {maskedEmail}
        <span
          style={{
            color: emailVerification?.status ? "green" : "",
            marginRight: "1rem",
          }}
        >
          {emailVerification?.status ? (
            <img src={Images.emailVerified} alt="" style={{ width: "1rem" }} />
          ) : (
            <SendIcon sx={{ fontSize: "1rem" }} />
          )}
        </span>
      </Typography>
    </div>
  );
};
export const Phone = (props: any) => {
  const phoneVerification = props?.verification?.find(
    (verificationItem: any) => verificationItem?.type === "phone"
  );
  const maskedEmail = maskInput(props.phone?.number, "phone");

  return (
    <div>
      <Typography
        fontSize="14px"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        {`${props.phone?.countryCode ? props.phone?.countryCode : ""} ${
          props.phone?.number ? maskedEmail : "N/A"
        } `}
        <span
          style={{
            color: phoneVerification?.status ? "green" : "#B42318",
            marginLeft: "10px",
          }}
        >
          {phoneVerification?.status ? "Verified" : "Not verified"}
        </span>
      </Typography>
    </div>
  );
};
export const Recommendations = (props: any) => {
  return (
    <div>
      <Typography
        fontSize="14px"
        sx={{
          textAlign: "center",
          color: props?.data?.length > 0 ? "green" : "#B42318",
          padding: "10px",
        }}
      >
        {props?.data?.length > 0 ? "Yes" : "No"}
      </Typography>
    </div>
  );
};
